import { AuditEvent } from '../../../entities/ticket/model/types';
import { getTicketAuditHistory as getTicketAuditHistoryApi } from '../../../entities/ticket/api/ticketApi';

export class GetTicketAuditHistoryUseCase {
  async execute(ticketId: string): Promise<AuditEvent[]> {
    return await getTicketAuditHistoryApi(ticketId);
  }
}




